// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1nuDH","inputWrap":"CustomTip_inputWrap__3Wkw7"};